import NotificationPanels from "./NotificationPanels";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { useEffect, useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import UploadIcon from "../assets/img/upload-icon.svg";
import { FileUploader } from "react-drag-drop-files";
import { useDispatch, useSelector } from "react-redux";
import { uploadFileViaMultipart } from "../Actions/personalDetailsActions";
import { getArnConfig } from "../Actions/TokenAction";
import { saveArnAuth, saveAuth } from "../Actions/AuthorizationAction";
import CandidateTab from "./CandidateTab";
import "../assets/css/candidate-tab-form.css";
import { useNavigate } from "react-router-dom";
import "../assets/css/authorization.css";
import { toast } from "react-toastify";
import { FOLDERPATH } from "../Constants/config";
import axios from "axios";
import Loader from "./Common/loader";
import ProgressHeading from "./Common/ProgressHeading";

function ArnAuthorization(){
  let navigate = useNavigate();
  const [signatureMode, setSignatureMode] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [showAuthCandidate, setShowAuthCandidate] = useState([]);
  const [fileSize, setFileSize] = useState();
  const [fileUpLoaded, setFileUpLoaded] = useState(null);
  const [clientId, setClientId] = useState('');
  const dispatch = useDispatch();
  const fileTypes = ["JPG", "PNG", "JPEG"];

  const [drawSignatureWidth, setDrawSignatureWidth] = useState(400);
  function clearSignature() {
    sigPad.clear();
  }
  const typeSignature = useRef("");
  const typeSignatureBase64 = useRef("");
  let sigPad = {};

  const signatureDrawn = useRef(1);
 
  const formValidation = (formValues) => {
    const errors = {};

    // console.log(formValues);

    if (formValues.mode == "1") {
      const typeSignatureValue = typeSignature.current.value;

      if (typeSignatureValue === "") {
        alert("Please enter name");
        errors.mode1 = "This field is required.";
      }
      if (!/^[a-zA-Z\s]*$/.test(typeSignatureValue)) {
        alert("Name must be albhabets (A-Z/a-z)");
        errors.mode1 = "Name must be albhabets (A-Z/a-z)";
      }

      //errors.mode = "This field is required.";
      //email.current.style.border = "1px solid red";
    } else {
      //email.current.style.border = "1px solid #E1E4EB";
    }

    if (formValues.mode == "2") {
      let signpadEmpty = sigPad.isEmpty();
      if (signpadEmpty) {
        alert("Please Draw Signature");
        errors.mode2 = "This field is required.";
      }

      //errors.mode = "This field is required.";
      //email.current.style.border = "1px solid red";
    } else {
      //email.current.style.border = "1px solid #E1E4EB";
    }

    if (formValues.mode == "3") {
      if (fileUpLoaded === null) {
        alert("Please upload file");
        errors.mode3 = "This field is required.";
      }

      //errors.mode = "This field is required.";
      //email.current.style.border = "1px solid red";
    } else {
      //email.current.style.border = "1px solid #E1E4EB";
    }

    return errors;
  };

  const signatureSubmitHandler = async(event) => {
    event.preventDefault();
    // Close the modal when submitting
    // setModalOpen(false);

    const formData = {};
    formData.mode = parseInt(signatureMode);

    const err = formValidation(formData);

    const isValidationPassed = Object.keys(err).length === 0;
    if (!isValidationPassed) {
      window.scroll({ top: 0, left: 0, behavior: "smooth" });
    } else {
      if (formData.mode == 1) {
        formData.typedSignature = typeSignatureBase64.current.value;
      } else if (formData.mode == 2) {
        formData.drawSignature = sigPad
          .getTrimmedCanvas()
          .toDataURL("image/png");
      }

      // console.log(sigPad.getTrimmedCanvas().toDataURL('image/png'));
      // console.log(sigPad.isEmpty());
      if (fileSize > 5242880 && formData.mode == 3) {
      } 
      if(isNaN(formData.mode)){
        let msg = "Please,Compete the authorization";
        toast.error(msg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return;
      }
      else {
        dispatch(saveArnAuth(formData));
        const headers = {
          "Content-Type": "application/json",
          "Username": "ibridge",
          "Password": "ibridge@2020",
        };
    
        //axios.defaults.baseURL = API_URL;
        let userLocalData = JSON.parse(localStorage.getItem('userVerification'));  
        let requestData={};
        requestData.token = userLocalData.id;
        setLoading(true);

        const { data } = await axios.post(FOLDERPATH + "/CandidateApi/arnAuthorization", requestData, {
            headers,
         });
         if(data){
          setLoading(false);
          navigate("../ArnThankyou");
          }
 
      }
    }
  };

  const storeOtpArnData = useSelector((state) => state.verifyOtpArn);
  const { otpArnData, load, err } = storeOtpArnData;

  console.log(otpArnData);
  useEffect(() => {
    const fetchData=async()=>{
      let tempToken=JSON.parse(localStorage.getItem("tempToken"));
      let data=await dispatch(getArnConfig(tempToken));
      setShowAuthCandidate(data?.data?.candidate_signature_config);
      setClientId(data?.data?.clientId);
      if(data?.data?.candidate_signature_config.includes("1")){
        setSignatureMode(2)
      }
      else if(data?.data?.candidate_signature_config.includes("2")){
        setSignatureMode(3)
      }
      else if(data?.data?.candidate_signature_config.includes("3")){
        setSignatureMode(1)
      }
   //    data?.data?.candidate_signature_config
    }
    fetchData();
   
  },[]);

  const handleChange = (file) => {
    //alert("x")

    setFileSize(file.size);
    setFileUpLoaded(file);
    console.log(JSON.stringify(file));
    if (file.size < 5242880) {
      dispatch(uploadFileViaMultipart("uploadedSignature", file));
    }
  };
  const typeSignatureHandler = (e) => {
    const textLength = e.target.value.length;
    console.log(textLength);
    const typedName = typeSignature.current.value;
    var c = document.getElementById("myCanvas");

    var ctx = c.getContext("2d");
    ctx.clearRect(0, 0, c.width, c.height);
    if (textLength <= 15) {
      ctx.font = "36px Comic Sans MS";
    } else if (textLength > 15 && textLength <= 25) {
      ctx.font = "30px Comic Sans MS";
    } else {
      ctx.font = "20px Comic Sans MS";
    }
    ctx.fillStyle = "black";
    ctx.textAlign = "center";
    ctx.fillText(typedName, c.width / 2, c.height / 2);

    // const base64Canvas = c.toDataURL("image/jpeg");

    var pngUrl = c.toDataURL(); // PNG is the default

    typeSignatureBase64.current.value = pngUrl;

    console.log(pngUrl);
  };

  const changeModeHandler = (mode) => {
    // console.log(mode);
    setSignatureMode(mode);
  };

    return (
        <>
         {isLoading && <Loader />}
         <NotificationPanels />
      <Header firstName={otpArnData?.data?.username} />
      <Sidebar />

      <section
        className="main-section candidate-tab-form"
        style={{ paddingTop: "60px" }}
      >
        {/* {isLoading && <Loader />} */}
        <div className="container-fluid">
          <div className="row">
            <div className="col-auto w-100-mbl bg-gray-mbl">
              <ProgressHeading/>
              {/* <CandidateTab activeTab={"Authorization"}/> */}
            </div>
            <div className="col-md-7 bg-gray-mbl">
            <div className="p-3">
            <h2 class="fnt-smi-bld">Authorization</h2>
            <p class="text-muted">Authorisation for verification process </p>
            <div className="authrization-doc">
              <p>Please note that AuthBridge will be conducting your employment background verification on behalf of your employer. Given below is the Authorization letter, where you need to sign to authorize for your background verification. You have right to deny and not sign the Authorization letter if you do not want to allow for verification. You are also required to go through our Privacy Policy. </p>
              <p>The employment verification report may include information regarding my character, reputation, personal characteristics; National Identity Verification; Education details; Employment history; References from professional and personal associates; Credit history; Court records (including criminal verification) as permitted by law; Health Check-up; Drug Test; Address Verification; and any other check as found relevant for the profile.</p>
            { clientId == 108942 && 
                <>
                <p className="fnt-smi-bld mb-0">
                “Privacy Notice: <br />
                </p>
                <p>
                Nagarro acts as the data fiduciary and engages appointed vendors to conduct background verification checks. By signing this authorization letter, you agree and acknowledge that your personal data will be collected, processed, and stored in compliance with applicable data protection laws. Detailed information about how your personal data is handled can be found at: 
                <a href="https://www.nagarro.com/hubfs/NagarroWebsiteRedesign-Aug2020/Assets/Docs/Applicant%20Privacy%20Notice-EN.pdf" target="_">
                  {" "}
                Applicant Privacy Notice-EN.pdf  “
                </a>
                </p>
                </>
            }  
            </div>
            <div className="p-1 rounded" style={{boxShadow:"rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px"}}>
            <ul
                className="nav nav-tabs inner-tabs-style2 mt-3"
                id="myTab"
                role="tablist"
              >
                 {showAuthCandidate && showAuthCandidate.map((val,ind)=>{
                  if(val == "1"){
                  return<>
                  {" "}
                <li className="nav-item d-flex justify-content-center align-items-center">
                  {" "}
                  <a
                    className={`nav-link2 ${signatureMode == 2 ? ' active' : ''}`}
                    id="drawSignature-tab"
                    data-toggle="tab"
                    href="#drawSignature"
                    role="tab"
                    aria-controls="drawSignature"
                    aria-selected="false"
                    onClick={() => changeModeHandler(2)}
                    style={{marginLeft:"-28px"}}
                  >
                    Draw Signature
                  </a>{" "}
                </li>
                  </>
                  }
                  if (val == "2") {
                    return (
                      <>
                        {" "}
                        <li className="nav-item d-flex justify-content-center align-items-center">
                          {" "}
                          <a
                            className={`nav-link2 ${
                              signatureMode == 3 ? " active" : ""
                            }`}
                            id="uploadSignature-tab"
                            data-toggle="tab"
                            href="#uploadSignature"
                            role="tab"
                            aria-controls="uploadSignature"
                            aria-selected="false"
                            onClick={() => changeModeHandler(3)}
                          >
                            Upload Signature
                          </a>{" "}
                        </li>
                      </>
                    );
                  }
                  if(val == "3"){
                    return<>
                   {" "}
                <li className="nav-item d-flex justify-content-center align-items-center">
                  {" "}
                  <a
                    className={`nav-link2 ${signatureMode == 1 ? ' active' : ''}`}
                    id="typeSignature-tab"
                    data-toggle="tab"
                    href="#typeSignature"
                    role="tab"
                    aria-controls="typeSignature"
                    aria-selected="true"
                    onClick={() => changeModeHandler(1)}
                    style={{marginRight:"-33px;"}}
                  >
                    Type Signature{" "}
                  </a>{" "}
                </li>
                    </>
                  }
                })}
              </ul>{" "}
              <div className="tab-content safari_only p-3" id="myTabContent">
                <div
                  className={`tab-pane fade ${signatureMode == 1 ? 'show active' : ''}`}
                  id="typeSignature"
                  role="tabpanel"
                  aria-labelledby="typeSignature-tab"
                >
                  {" "}
                  <div className="form-group">
                    {" "}

                    <label>Your Name</label>{" "}
                    <input
                      type="text"
                      className="form-control"
                      maxLength="35"
                      name="typeSignature"
                      ref={typeSignature}
                      onChange={typeSignatureHandler}
                    />{" "}
                  </div>
                  <div className="text-center">
                    <canvas
                      id="myCanvas"
                      height="200"
                      width="1000"
                      className="common-white-box w-100"
                      style={{ border: "1px solid #d3d3d3" }}
                    >
                      {" "}
                      Your browser does not support the HTML canvas tag.{" "}
                    </canvas>
                  </div>
                  <input
                    type="hidden"
                    name="typeSignatureBase64"
                    ref={typeSignatureBase64}
                  />
                  <div className="text-right">
                    {" "}
                    <small className="text-muted">
                      Date: {new Date().getDate()}/{new Date().getMonth() + 1}/
                      {new Date().getFullYear()}{" "}
                    </small>{" "}
                  </div>{" "}
                </div>
                <div
                  className={`tab-pane fade ${signatureMode == 2 ? 'show active' : ''}`}

                  id="drawSignature"
                  role="tabpanel"
                  aria-labelledby="drawSignature-tab"
                >
                  <div className="text-center draw-signature-wrapper">
                    <SignatureCanvas
                      ref={(ref) => {
                        sigPad = ref;
                      }}
                      penColor="black"
                      backgroundColor="rgba(225,225,225, 0.4)"
                      canvasProps={{
                        width: drawSignatureWidth,
                        height: 180,
                        className: "sigCanvas",
                      }}
                    />
                  </div>
                  <input
                    type="hidden"
                    name="signatureDrawn"
                    ref={signatureDrawn}
                    value="0"
                  />
                  <center>
                    <button className="btn-secondary clear-btn" onClick={clearSignature}>
                      Clear
                    </button>
                  </center>
                {" "}
                  <div className="text-right">
                    {" "}
                    <small className="text-muted">
                      Date: {new Date().getDate()}/{new Date().getMonth() + 1}/
                      {new Date().getFullYear()}
                    </small>{" "}
                  </div>{" "}
                </div>
                <div
                  className={`tab-pane fade ${signatureMode == 3 ? 'show active' : ''}`}

                  id="uploadSignature"
                  role="tabpanel"
                  aria-labelledby="uploadSignature-tab"
                >
                  {" "}
                  <div
                    className="common-white-box d-flex align-items-center justify-content-center flex-column kih-drap-drop"
                    style={{ minHeight: "180px" }}
                  >
                    {" "}
                    <img src={UploadIcon} alt="" className="mb-2" />{" "}
                    <div className="text-center pl-2 pr-2">
                      {" "}
                      <FileUploader
                        handleChange={handleChange}
                        name="file"
                        maxSize="5"
                        onSizeError={(file) => {
                          alert("file size larger than 5 mb");
                        }}
                        types={fileTypes}
                      />
                    <br />{" "}
                    {fileUpLoaded != null ? <h6>{fileUpLoaded.name}</h6> : ""}
                    <span className="text-muted">
                      PNG, JPG, JPEG (max. 5Mb)
                    </span>{" "}
                  </div>{" "}
                </div>
                <div className="text-right mt-3">
                  {" "}
                  <small className="text-muted">
                    Date: {new Date().getDate()}/{new Date().getMonth() + 1}/
                    {new Date().getFullYear()}
                  </small>{" "}
                </div>{" "}
              </div>{" "}
            </div>
         
            </div>
            <center className="mt-4">
              {" "}
              <input
                type="hidden"
                name="signatureMode"
                value={signatureMode}
              />{" "}
              <button
                className="btn btn-primary btn-lg"
                onClick={signatureSubmitHandler}
              >
                Accept &amp; Continue
              </button>{" "}
            </center>
            </div>
            </div>
            </div>
            </div>
            </section>
    
      {/* <div
        className={`dashboard custom-modal-dialog show`}
        id="authorizeBgvPopup"
      >
        {" "}
        <div className="modal-wrapper authorization-modal">
          <div
            className="modal-content p-4"
            id="authorization-modal"
            style={{ overflow: "unset" }}
          >
            <h3 className="fnt-smi-bld mb-3 auth-header">
              Authorize background verification
            </h3>{" "}
            <div className="text-wrapper-modal">
              <p className="text-muted">
                Please note that AuthBridge will be conducting your employment
                background verification on behalf of your employer. Given below
                is the Authorization letter, where you need to sign to authorize
                for your background verification. You have right to deny and not
                sign the Authorization letter if you do not want to allow for
                verification. You are also required to go through our Privacy
                Policy.
              </p>
              <p className="text-muted">
                The employment verification report may include information
                regarding my character, reputation, personal characteristics,
                National Identity Verification, Education details, Employment
                history, References from professional and personal associates,
                Credit history, Court records (including criminal verification)
                as permitted by law, Health Check-up, Drug Test, Address
                Verification, and any other check as found relevant for the
                profile.
              </p>
              </div>
             
          </div>
        </div>
      </div> */}
        </>
    )
} 

export default ArnAuthorization;